import { useMemo } from "react";
import useAutenticacaoJwt from "@auth/services/jwt/useAutenticacaoJwt";
import FuseNavigationHelper from "@fuse/utils/FuseNavigationHelper";
import { useNavigationContext } from "../contexts/useNavigationContext";
import { useMenuListar } from "@/permissoes/hooks/usePermissoes";
import { aplicarPermissoesNavegacao, montarMapaEstadoMenu } from "@/permissoes/menuPermissoes";

function useNavigationItems() {
	// -------------------------------- STATES --------------------------------
	const { navigationItems } = useNavigationContext();
	const { user, isAuthenticated } = useAutenticacaoJwt();

	const isSpaceUser = Boolean(user?.eh_usuario_space);

	// -------------------------------- QUERIES -------------------------------
	const { data: menu } = useMenuListar(isAuthenticated && Boolean(user) && !isSpaceUser);

	// ----------------------------- DERIVED STATE ----------------------------
	const data = useMemo(() => {
		const arvore = FuseNavigationHelper.unflattenNavigation(navigationItems);
		const mapaEstado = montarMapaEstadoMenu(menu ?? [], user?.id_cad_grupo ?? 0);

		return aplicarPermissoesNavegacao(arvore, { isSpaceUser, mapaEstado });
	}, [navigationItems, menu, user, isSpaceUser]);

	const flattenData = useMemo(() => FuseNavigationHelper.flattenNavigation(data), [data]);

	// -------------------------------- RETURN --------------------------------
	return { data, flattenData };
}

export default useNavigationItems;
